<div class="columns">
  <wo-recurrence-schedule-date-range
    class="column"
    [startDate]="formGroup.controls.startDate"
    [endDate]="formGroup.controls.endDate"
    [readonly]="readonly"
    [minStart]="minStart"
  />
</div>
<div class="columns" [issDisplayAfter]="[formGroup.controls.startDate, formGroup.controls.endDate]">
  <wo-recurrence-schedule-configurator
    class="column"
    [issFormGroup]="formGroup"
    [readonly]="readonly"
  />
</div>
